
    import './styles.scoped.css';
    export default {
  "top-navigation": "awsui_top-navigation_1ca1i_fxq4i_145",
  "padding-box": "awsui_padding-box_1ca1i_fxq4i_177",
  "medium": "awsui_medium_1ca1i_fxq4i_189",
  "narrow": "awsui_narrow_1ca1i_fxq4i_189",
  "hidden": "awsui_hidden_1ca1i_fxq4i_199",
  "\t": "awsui_\t_1ca1i_fxq4i_1",
  "identity": "awsui_identity_1ca1i_fxq4i_212",
  "identity-link": "awsui_identity-link_1ca1i_fxq4i_212",
  "no-logo": "awsui_no-logo_1ca1i_fxq4i_232",
  "logo": "awsui_logo_1ca1i_fxq4i_236",
  "title": "awsui_title_1ca1i_fxq4i_247",
  "inputs": "awsui_inputs_1ca1i_fxq4i_263",
  "search": "awsui_search_1ca1i_fxq4i_270",
  "search-expanded": "awsui_search-expanded_1ca1i_fxq4i_275",
  "utilities": "awsui_utilities_1ca1i_fxq4i_280",
  "utility-wrapper": "awsui_utility-wrapper_1ca1i_fxq4i_292",
  "utility-wrapper-last": "awsui_utility-wrapper-last_1ca1i_fxq4i_307",
  "utility-type-button-primary-button": "awsui_utility-type-button-primary-button_1ca1i_fxq4i_307",
  "utility-type-menu-dropdown": "awsui_utility-type-menu-dropdown_1ca1i_fxq4i_320",
  "utility-type-button-link": "awsui_utility-type-button-link_1ca1i_fxq4i_336",
  "utility-link-icon": "awsui_utility-link-icon_1ca1i_fxq4i_350",
  "utility-button-external-icon": "awsui_utility-button-external-icon_1ca1i_fxq4i_354",
  "trigger": "awsui_trigger_1ca1i_fxq4i_358"
};
  